import { Button, Text, theme } from 'components';
import React, { useEffect } from 'react';

import { useHistory } from 'react-router';
import styled from 'styled-components';
import BannerAlert from '../../components/GlobalBanner/BannerAlert';
import useNotification from '../../../components/AppHeader/useNotification';

const DisabledAutoCoopBanner = () => {
  const {
    disabledAutoCoopNotification,
    setDisabledAutoCoopNotification,
    getDisabledAutoCoopNotification,
    markRead,
  } = useNotification();

  const history = useHistory();

  useEffect(() => {
    getDisabledAutoCoopNotification();
  }, []);

  const handleClose = async () => {
    await markRead(disabledAutoCoopNotification!.id);
    setDisabledAutoCoopNotification(undefined);
  };

  if (!disabledAutoCoopNotification) return null;

  return (
    <StyledBannerAlert
      message={
        <TextContainer>
          <TextTopRow>
            <BoldText>{disabledAutoCoopNotification.body}</BoldText>
            <StatusButton
              type="primary"
              size="small"
              data-cy="button-check-status"
              onClick={() => history.push('/coop/organizations')}
            >
              Check Status
            </StatusButton>
          </TextTopRow>
          <Text>Please contact the organization(s) for more information.</Text>
        </TextContainer>
      }
      backgroundColor={theme.red1}
      type={'error'}
      showIcon
      closable
      onClose={handleClose}
      data-cy="disabled-auto-coop-banner"
    />
  );
};

export default DisabledAutoCoopBanner;
const StyledBannerAlert = styled(BannerAlert)`
  display: flex;
  margin-bottom: 10px;
  height: fit-content;
  border: 1px solid ${theme.red2};
  border-radius: 5px;

  .ant-alert-icon {
    align-self: start;
  }

  .ant-alert-close-icon {
    align-self: start;
  }
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin-right: 12px;
`;

const TextTopRow = styled.div`
  display: flex;
  align-items: space-between;
`;

const BoldText = styled(Text)`
  font-weight: 600;
`;

const StatusButton = styled(Button)`
  margin-left: auto;
  margin-right: 5px;
`;
